'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _components = require('../../components');

var _DefaultString = require('../../helpers/DefaultString');

var _Product = require('../../helpers/Product');

var _auth = require('../../redux/modules/auth');

var _Checkbox = require('../Checkbox/Checkbox');

var _TermsAndPrivacy = require('./TermsAndPrivacy.scss');

var _TermsAndPrivacy2 = _interopRequireDefault(_TermsAndPrivacy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TermsAndPrivacy = (_dec = (0, _reactRedux.connect)(function (state) {
  return { appInfo: state.appInfo, auth: state.auth, acceptedTerms: state.auth.termsPrivacy };
}, { editTermsAndPrivacy: _auth.editTermsAndPrivacy }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(TermsAndPrivacy, _Component);

  function TermsAndPrivacy() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, TermsAndPrivacy);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TermsAndPrivacy.__proto__ || (0, _getPrototypeOf2.default)(TermsAndPrivacy)).call.apply(_ref, [this].concat(args))), _this), _this.componentWillMount = function () {
      _this.props.editTermsAndPrivacy(false);
    }, _this.onTermsClick = function () {
      var formatMessage = _this.props.intl.formatMessage;

      var url = (0, _Product.getTermsString)(formatMessage, _this.props.auth.productName, _this.props.appInfo.excludeHeader);
      window.open(url, '_blank');
    }, _this.onPrivacyClick = function () {
      var formatMessage = _this.props.intl.formatMessage;

      var url = (0, _Product.getPrivacyString)(formatMessage, _this.props.auth.productName, _this.props.appInfo.excludeHeader);
      window.open(url, '_blank');
    }, _this.handleChange = function (isChecked) {
      _this.props.editTermsAndPrivacy(isChecked);
    }, _this.hasTermsAndPrivacy = function () {
      return _this.props.appInfo.agreement && _this.props.appInfo.agreement[_this.props.auth.productName] && _this.props.appInfo.agreement[_this.props.auth.productName].checkboxEnabled;
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(TermsAndPrivacy, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          acceptedTerms = _props.acceptedTerms,
          theme = _props.theme;
      var formatMessage = this.props.intl.formatMessage;

      var hasTermsAndPrivacy = this.hasTermsAndPrivacy();
      var termsCheckboxId = 'termsAndPrivacy';

      return hasTermsAndPrivacy ? _react2.default.createElement(
        'div',
        { className: className },
        _react2.default.createElement(
          'div',
          { className: _TermsAndPrivacy2.default.termsAndPrivacy },
          _react2.default.createElement(_components.Checkbox, { theme: theme, checkboxId: termsCheckboxId, isChecked: acceptedTerms, onCheckboxChange: this.handleChange }),
          _react2.default.createElement(
            'div',
            { className: _TermsAndPrivacy2.default.message },
            _react2.default.createElement(_reactIntl.FormattedMessage, (0, _extends3.default)({}, _DefaultString.translations.TermsAndPrivacy, {
              values: {
                lineBreak: _react2.default.createElement('br', null),
                terms: _react2.default.createElement(
                  'span',
                  { className: _TermsAndPrivacy2.default.terms, onClick: this.onTermsClick },
                  formatMessage(_DefaultString.translations.TermsConditions)
                ),
                privacy: _react2.default.createElement(
                  'span',
                  { className: _TermsAndPrivacy2.default.privacy, onClick: this.onPrivacyClick },
                  formatMessage(_DefaultString.translations.PrivacyPolicy)
                ) }
            }))
          )
        )
      ) : null;
    }
  }]);
  return TermsAndPrivacy;
}(_react.Component), _class2.defaultProps = {
  className: '',
  acceptedTerms: false,
  theme: _Checkbox.CheckboxTheme.LIGHT
}, _class2.propTypes = {
  acceptedTerms: _react.PropTypes.bool,
  appInfo: _react.PropTypes.object,
  auth: _react.PropTypes.object,
  className: _react.PropTypes.string,
  editTermsAndPrivacy: _react.PropTypes.func.isRequired,
  intl: _reactIntl.intlShape.isRequired,
  theme: _react.PropTypes.string
}, _temp2)) || _class);
exports.default = TermsAndPrivacy;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TermsAndPrivacy/TermsAndPrivacy.js
// module id = 1989
// module chunks = 0